<template>
  <DialogHeader>
    <template #right>
      <div class="font-medium text-green-900 cursor-pointer" @click="close()">
        Okay
      </div>
    </template>
    {{ title }}
  </DialogHeader>
  <DialogContent>
    <div>
      <template v-if="isWebPlan">
        Looks like you purchased this subscription on Dacr.com. You'll need to
        manage your subscription there.
      </template>

      <template v-else>
        Looks like you purchased this subscription on your
        {{ platform }} device using in-app payments. You'll need to manage your
        subscription from that platform.
      </template>
    </div>

    <Message
      v-if="!webviewStore.isActive"
      type="success"
      icon="Info"
      class="mt-5"
    >
      <span
        class="font-semibold font-secondary text-[14px] leading-[20px] mb-3"
      >
        Save money
      </span>
      by cancelling your subscription on that platform and resubscribe on
      Dacr.com.
    </Message>
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-full tablet-h:w-auto" primary @click="close()">
      Okay
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, Message } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { useBillingStore } from '@/features/billing/store'
import { computed } from 'vue'
import { capitalize } from '@/shared/utils/string'
import { useWebviewStore } from '@/shared/stores/webview'
import { PlatformType } from '@/shared/graphql/legacy/generated'

const { close } = useDialog()

const props = defineProps<{
  type: 'change' | 'cancel' | 'pay'
}>()

const billingStore = useBillingStore()
const webviewStore = useWebviewStore()

const platform = computed(() =>
  capitalize(billingStore.billing?.plan.platform || '')
)

const isWebPlan = computed(
  () => billingStore.billing?.plan.platform === PlatformType.Web
)

const title = computed(() => {
  if (props.type === 'pay') return "Can't pay here"
  return `Can't ${props.type} your plan here`
})
</script>
